import {JsonProperty} from 'json-typescript-mapper';

export class PrivacyPolicy {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('active')
  public active?: boolean;

  @JsonProperty('documentName')
  public documentName?: string;

  constructor() {
    this.id = void 0;
    this.created = void 0;
    this.updated = void 0;
    this.active = void 0;
    this.documentName = void 0;
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/privacy-policy.model.ts